import { render, staticRenderFns } from "./YinhuashuiTable.vue?vue&type=template&id=420b82aa&scoped=true"
import script from "./YinhuashuiTable.vue?vue&type=script&lang=js"
export * from "./YinhuashuiTable.vue?vue&type=script&lang=js"
import style0 from "./YinhuashuiTable.vue?vue&type=style&index=0&id=420b82aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b82aa",
  null
  
)

export default component.exports